export function getQueryString(query: any) {
  let queryString = "";
  let str = [];

  for (var p in query) {
    var type = typeof query[p];
    if (type === "object") {
      var arr = query[p];
      for (var v in arr) {
        if (arr[v] !== null)
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(arr[v]));
      }
    } else {
      if (query[p] !== null)
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(query[p]));
    }
  }
  queryString = str.join("&");
  return queryString;
}

export class UnauthorizedError extends Error {
  detail: string;

  constructor(message: string, detail: string) {
    super(message);
    this.name = "UnauthorizedError";
    this.detail = detail;
  }
}

/**
 * Whether a rejection from the shared axios wrapper is a 403 — the API refusing this request
 * for a signed-in user who may not have it (`PermissionError` → `403 Forbidden`).
 *
 * Matches the response interceptor's normalized 4xx shape, whose `status` is at the TOP level
 * (`{ message, status, data }`), never `err.response.status`. A 401 is never a match: the
 * interceptor throws an `UnauthorizedError` for it, which carries no status at all, and it
 * has already cleared the token by then. A page uses this to show the shared no-access state
 * instead of toasting the server's bare "Forbidden" (AKL-939).
 * @param err the caught rejection
 * @returns true only for a normalized 403
 */
export const isForbiddenError = (err: unknown): boolean =>
  typeof err === "object" &&
  err !== null &&
  (err as { status?: unknown }).status === 403;

export const pageSize = 25;

/**
 * The stand-in the response interceptor puts on a normalized error when the API sent
 * no `detail`. It is not a message for a user: it is untranslated, and says nothing
 * about what failed. Anything that surfaces a normalized error's `message` on screen
 * must treat this value as "no detail" and show its own wording instead.
 */
export const NO_DETAIL_MESSAGE = "Request error";
